/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { Box, Button, Grid, Link, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useSelector } from "react-redux";
import { RootState, useAppDispatch } from "@store/store";
import { InactivityHandler } from "@components/InactivityHandler";
import CustomRightImage from "@components/CustomRightImagev2";
import { setModalErrorVisible } from "@store/slices/appSlice";
import { useLazyGetCuentasByIdQuery } from "@api/account";
import { ApiError } from "@interfaces/response";
import IconSpeed from "@components/Images/IconSpeed";

const Rechazo = () => {
  const theme = useTheme();
  const dispatch = useAppDispatch();
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down("md"));

  const personalData = useSelector((state: RootState) => state.register.personal_data);

  const [getAccountData] = useLazyGetCuentasByIdQuery();

  const [name, setName] = useState("");

  const handleClick = async () => {
    console.log("Reactivar solicitud...");
  };

  const fetchData = async () => {
    try {
      const response = await getAccountData({ id: personalData.id }).unwrap();
      const account_data = response.data;
      const fullName = `${account_data.name} ${account_data.last_name} ${account_data.last_name_2}`;
      setName(fullName);
    } catch (error) {
      dispatch(setModalErrorVisible({ open: true, error: error as ApiError }));
    }
  };

  useEffect(() => {
    document.body.style.backgroundColor =
      theme?.palette?.screenBackground?.backgroundColor || theme?.palette?.primary?.dark;
    fetchData();

    return () => {
      document.body.style.backgroundColor = "";
    };
  }, []);

  return (
    <Grid container height="100%">
      <Grid item xs={12} md={8} mt={5}>
        <InactivityHandler />
        <Box>
          <Typography
            variant={isMobileOrTablet ? "h4" : "h3"}
            color={theme?.palette?.screenBackground?.textColor || theme?.palette?.primary?.light}
            fontWeight={500}
            align="center"
          >
            ¡Hola!
          </Typography>

          <Typography
            variant={isMobileOrTablet ? "h4" : "h3"}
            color={theme?.palette?.screenBackground?.textColor || theme?.palette?.primary?.light}
            fontWeight={500}
            align="center"
          >
            {name}
          </Typography>

          <Typography
            variant={isMobileOrTablet ? "body2" : "body1"}
            color={theme?.palette?.screenBackground?.subTextColor || theme?.palette?.primary?.light}
            align="center"
            mt={4}
          >
            Tu solicitud se desactivo por inactividad.
          </Typography>

          <Typography
            variant={isMobileOrTablet ? "body2" : "body1"}
            color={theme?.palette?.screenBackground?.textColor || theme?.palette?.primary?.light}
            align="center"
            mt={4}
            fontWeight={700}
          >
            Si deseas continuar, puedes reactivarla ahora.
          </Typography>

          <Box display="flex" justifyContent="center" mt={4}>
            <IconSpeed fill={theme.palette.primary.dark} />
          </Box>

          <Box display="flex" justifyContent="center" mt={4}>
            <Button variant="default" onClick={handleClick}>
              Reactivar solicitud
            </Button>
          </Box>

          <Typography
            variant={isMobileOrTablet ? "body2" : "body1"}
            color={theme?.palette?.screenBackground?.subTextColor || theme?.palette?.primary?.light}
            align="center"
            mt={4}
          >
            Para cualquier duda o aclaración contáctanos a: <br />
            Tel:{" "}
            <Link
              href="tel:+525591044964"
              color={theme?.palette?.screenBackground?.subTextColor || theme?.palette?.primary?.light}
            >
              55 9104 4964
            </Link>
          </Typography>

          <Typography
            variant={isMobileOrTablet ? "body2" : "body1"}
            color={theme?.palette?.screenBackground?.subTextColor || theme?.palette?.primary?.light}
            align="center"
            fontWeight={300}
            mt={1}
          >
            Correo:{" "}
            <Link
              href="mailto:contacto@lendia.mx"
              color={theme?.palette?.screenBackground?.subTextColor || theme?.palette?.primary?.light}
            >
              contacto@lendia.mx
            </Link>
          </Typography>
        </Box>
      </Grid>

      {!isMobileOrTablet && (
        <Grid item xs={12} md={4}>
          <CustomRightImage />
        </Grid>
      )}
    </Grid>
  );
};

export default Rechazo;
